// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import './ItemCard.css';
// import phoneIcon from '../assets/phone-icon.png'; // Ensure you have these icons in your src folder
// import whatsappIcon from '../assets/whatsapp-icon.png';
// import smsIcon from '../assets/sms-icon.png';
// import editIcon from '../assets/edit-icon.png'; // Ensure you have this icon in your src folder

// const ItemCard = ({ item }) => {
//   const { id, picture, name, category, condition, relevant, phone } = item;
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const handleImageClick = () => {
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//   };

//   const handleCall = () => {
//     window.location.href = `tel:${phone}`;
//   };

//   const handleWhatsApp = () => {
//     window.location.href = `https://wa.me/${phone}`;
//   };

//   const handleSMS = () => {
//     window.location.href = `sms:${phone}`;
//   };

//   return (
//     <>
//       <div className="item-card">
//         <img src={picture} alt={name} className="item-image" onClick={handleImageClick} />
//         <div className="item-details">
//           <h3>{name.substring(0, 15) + '...'}</h3>
//           <p>{condition}</p>
//           <p style={{ color: relevant ? 'green' : 'red' }}>
//             {relevant ? 'Relevant' : 'Not Relevant'}
//           </p>
//           <div className="action-icons">
//             <img src={phoneIcon} className="action-icon" alt="Call" onClick={handleCall} />
//             <img src={whatsappIcon} className="action-icon" alt="WhatsApp" onClick={handleWhatsApp} />
//             <img src={smsIcon} className="action-icon" alt="SMS" onClick={handleSMS} />
//             <Link to={`/edit/${id}`} className="edit-button">
//               <img src={editIcon} className="edit-icon" alt="Edit" />
//             </Link>
//           </div>
//         </div>
//       </div>

//       {isModalOpen && (
//         <div className="modal" onClick={handleCloseModal}>
//           <div className="modal-content">
//             <span className="close" onClick={handleCloseModal}>&times;</span>
//             <img className="modal-image" src={picture} alt={name} />
//             <h3>{name}</h3>
//             <p>{condition}</p>
//             <p style={{ color: relevant ? 'green' : 'red' }}>
//               {relevant ? 'Relevant' : 'Not Relevant'}
//             </p>
//             <div className="action-icons">
//               <img src={phoneIcon} className="action-icon" alt="Call" onClick={handleCall} />
//               <img src={whatsappIcon} className="action-icon" alt="WhatsApp" onClick={handleWhatsApp} />
//               <img src={smsIcon} className="action-icon" alt="SMS" onClick={handleSMS} />
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ItemCard;

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ItemCard.css';
import phoneIcon from '../assets/phone-icon.png'; // Ensure you have these icons in your src folder
import whatsappIcon from '../assets/whatsapp-icon.png';
import smsIcon from '../assets/sms-icon.png';
import editIcon from '../assets/edit-icon.png'; // Ensure you have this icon in your src folder

const ItemCard = ({ item }) => {
  const { id, picture, name, category, condition, relevant, phone, uploadDate ,region,description , nameM} = item;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleImageClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCall = () => {
    window.location.href = `tel:${phone}`;
  };

  const handleWhatsApp = () => {
    let temp = phone.substring(1);
    temp = `972${temp}`;
    window.location.href = `https://wa.me/${temp}`;
  };

  const handleSMS = () => {
    window.location.href = `sms:${phone}`;
  };

  const formatDate = (timestamp) => {
    const date = timestamp.toDate();
    return date.toLocaleDateString('he-IL');
  };

  return (
    <>
      <div className="item-card">
        <img src={picture} alt={name} className="item-image" onClick={handleImageClick} />
        <div className="item-details">
          <h3>{name}</h3>
          <p>{condition}</p>
          <p>{region}</p>
          <p>{formatDate(uploadDate)}</p>
          <p style={{ color: relevant ? 'green' : 'red' }}>
            {relevant ? 'רלוונטי' : 'לא רלוונטי'}
          </p>
          <p>{nameM}</p>
          <div className="action-icons">
            <img src={phoneIcon} className="action-icon" alt="Call" onClick={handleCall} />
            <img src={whatsappIcon} className="action-icon" alt="WhatsApp" onClick={handleWhatsApp} />
            <img src={smsIcon} className="action-icon" alt="SMS" onClick={handleSMS} />
            <Link to={`/edit/${id}`} className="edit-button">
              <img src={editIcon} className="edit-icon" alt="Edit" />
            </Link>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="modal" onClick={handleCloseModal}>
          <div className="modal-content">
            <span className="close" onClick={handleCloseModal}>&times;</span>
            <img className="modal-image" src={picture} alt={name} />
            <h3>{name}</h3>
            <p>{condition}</p>
            <p>{region}</p>
            <p>{description}</p>
            <p>{formatDate(uploadDate)}</p>
            <p style={{ color: relevant ? 'green' : 'red' }}>
              {relevant ? 'רלוונטי' : 'לא רלוונטי'}
            </p>
            <p>{nameM}</p>
            <div className="action-icons">
              <img src={phoneIcon} className="action-icon" alt="Call" onClick={handleCall} />
              <img src={whatsappIcon} className="action-icon" alt="WhatsApp" onClick={handleWhatsApp} />
              <img src={smsIcon} className="action-icon" alt="SMS" onClick={handleSMS} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ItemCard;
